import { render, staticRenderFns } from "./CortexFullscreen.vue?vue&type=template&id=61e058c1&scoped=true"
import script from "./CortexFullscreen.vue?vue&type=script&lang=js"
export * from "./CortexFullscreen.vue?vue&type=script&lang=js"
import style0 from "./CortexFullscreen.vue?vue&type=style&index=0&id=61e058c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e058c1",
  null
  
)

export default component.exports